import React from 'react'
import { Typography, Box, Grid } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import LandingPagePost from '../LandingPage/LandingPagePost'
import { PostLink } from '../../types/landingPage'

export interface RelatedPostsProps {
  links: PostLink[]
  title?: string
  displayClass?: string
  headerClassName?: string
  sectionClass?: string
}

const RelatedPosts: React.FC<RelatedPostsProps> = ({
  title,
  links,
  displayClass,
  headerClassName,
  sectionClass,
}) => {
  const { classes, cx } = useStyles()
  return (
    <Box className={displayClass} component="main">
      <Box className={cx(classes.main, sectionClass)}>
        {title && (
          <Box>
            <Typography
              className={cx(classes.headerTitle, headerClassName)}
              variant="h2"
            >
              {title}
            </Typography>
          </Box>
        )}
        <Grid className={classes.containerFlex}>
          {links.map((link) => (
            <Grid item className={classes.postContent} key={link.contentful_id}>
              <LandingPagePost link={link} />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  )
}

const useStyles = makeStyles()((theme) => ({
  main: {
    backgroundColor: theme.palette.primary.dark,
    maxWidth: '100%',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'column',
    paddingBottom: '5.75rem',
    paddingTop: '5.75em',
    [theme.breakpoints.down('md')]: {
      paddingBottom: '3.75rem',
      paddingTop: '3.75em',
      flexWrap: 'unset',
    },
  },
  containerFlex: {
    display: 'flex',
    flexFlow: 'row wrap',
    gridColumnGap: '2em',
    [theme.breakpoints.down('md')]: {
      display: 'flex',
      flexFlow: 'row wrap',
    },
  },
  postContent: {
    flexGrow: 1,
    minWidth: '20rem',
    flexBasis: '30%',
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    marginBottom: '2em',
    marginRight: '0em',
    '@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)': {
      marginRight: '2em',
    },
    '@media all and (max-width:60rem) and (-ms-high-contrast: none), (-ms-high-contrast: active) ':
      {
        marginRight: '0',
      },

    [theme.breakpoints.down('md')]: {
      flexGrow: 0,
      minWidth: 0,
      flexBasis: '100%',
    },
  },
  headerTitle: {
    color: 'white',
    textAlign: 'center',
    marginBottom: '3.64rem',
    [theme.breakpoints.down('md')]: {
      fontSize: '1.8125rem',
      lineHeight: 1.312,
      marginBottom: '2.1825rem',
    },
  },
}))

export default RelatedPosts
